export default "__VITE_ASSET__BtgmKorn__"